export const getContect = store => store.contect
